//基础dom
var Utils = {
    hasClass(el, domClass) {
        return el.className.match(new RegExp('(\\s|^)' + domClass + '(\\s|$)'));
    },
    addClass(el, domClass) {
        if (!this.hasClass(el, domClass)) el.className += " " + domClass;
    },
    removeClass(el, domClass) {
        if (this.hasClass(el, domClass)) {
            var reg = new RegExp('(\\s|^)' + domClass + '(\\s|$)');
            el.className = el.className.replace(reg, ' ');
        }
    },
    toggleClass(el, domClass) {
        if (this.hasClass(el, domClass)) {
            this.removeClass(el, domClass);
        } else {
            this.addClass(el, domClass);
        }
    },
    isNumeric(obj) {
        return !Array.isArray(obj) && (obj - Number.parseFloat(obj) + 1) >= 0;
    }
};

Utils.getQueryParams = function (name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return r[2];
    return null;
}

Utils.getQueryParam = function (path, name) {
    var pathsearch = path.split('?')[1] || '';
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = pathsearch.match(reg);
    if (r != null) return r[2];
    return null;
}

//浮点数运算
Utils.accMul = function (arg1, arg2) {
    if (!this.isNumeric(arg1) || !this.isNumeric(arg2)) {
        return;
    }
    var m = 0, s1 = arg1.toString(), s2 = arg2.toString();
    try {
        m += s1.split(".")[1].length;
    } catch (e) {
    }
    try {
        m += s2.split(".")[1].length;
    }
    catch (e) {
    }
    return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
};
// 时间戳转时间
Utils.chengDateTime = function (time) {
    if(!time){
        return '';
    }
    const date = new Date(+time);
    var year = date.getFullYear().toString().padStart(2,'0');
    var month = (date.getMonth() + 1).toString().padStart(2,'0');
    var day = date.getDate().toString().padStart(2,'0');
    var hour = date.getHours().toString().padStart(2,'0');
    var minute = date.getMinutes().toString().padStart(2,'0');
    var sec = date.getSeconds().toString().padStart(2,'0');
    return `${year}-${month}-${day} ${hour}:${minute}:${sec}`
}
Utils.getMaxPrecision = function (arg1, arg2) {
    if (!this.isNumeric(arg1) || !this.isNumeric(arg2)) {
        return -1;
    }
    var arg1String = Number(arg1).toString(),
        arg2String = Number(arg2).toString();
    var arg1Precision = arg1String.indexOf(".") == -1 ? 0 : arg1String.split(".")[1].length,
        arg2Precision = arg2String.indexOf(".") == -1 ? 0 : arg2String.split(".")[1].length;
    var finalPrecision = Math.max(arg1Precision, arg2Precision);
    return finalPrecision;
};

Utils.timeStamp = function(timeStr){
    console.log(timeStr,'timeStr');
    if(!timeStr){
        return;
    }
    const timeArr= timeStr.split(':');
    timeArr[0] = timeArr[0] * 60 * 60 * 1000;
    timeArr[1] = timeArr[1] * 60 * 1000;
    const time = timeArr[0] + timeArr[1];
    return time;
}
Utils.checkNullParameter = function (param) {
    if (param == null) return "--";
    if (param == '') return "--";
    return param;
};

Utils.postfixPercent = function (param) {
    if (!param) return param;
    if (!Utils.isNumeric(param)) return param;

    return `${param}%`;
}

Utils.getPrecision = function (number) {
    if (!this.isNumeric(number)) return -1;
    if (typeof number == "number") {
        number = Number(number).toString();
    }
    var precision = 0;
    if (number.indexOf(".") != -1) {
        precision = number.split(".")[1].length;
    }
    return precision;
};

Utils.formatDate = function (date, format) {
    var o = {
        "M+": date.getMonth() + 1, //month
        "d+": date.getDate(), //day
        "h+": date.getHours(), //hour
        "m+": date.getMinutes(), //minute
        "s+": date.getSeconds(), //second
        "q+": Math.floor((date.getMonth() + 3) / 3), //quarter
        "S": date.getMilliseconds() //millisecond
    };

    if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
        if (o.hasOwnProperty(k)) {
            if (new RegExp("(" + k + ")").test(format)) {
                format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
            }
        }
    }
    return format;
}

Utils.setSessionStorage = function (key, value) {
    if (!key || !value) {
        return;
    }
    sessionStorage.setItem(key, value);
}
Utils.getSessionStorage = function (key) {
    if (!key) {
        return;
    }
    return sessionStorage.getItem(key);
}
Utils.deleteSessionStorage = function (key) {
    if (!key) {
        return;
    }
    sessionStorage.clear(key);
}

Utils.setLocalStorage = function (key, value) {
    if (!key || !value) {
        return;
    }
    localStorage.removeItem(key);
    localStorage.setItem(key, JSON.stringify(value));
}
Utils.getLocalStorage = function (key) {
    if (!key) {
        return;
    }
    var value = localStorage.getItem(key);
    return JSON.parse(value);
}
Utils.clearLocalStorage = function (key) {
    localStorage.removeItem(key);
}
Utils.setCookie = function (c_name, value, expiredays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + expiredays);
    document.cookie = c_name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString()) + ";path=/";
};

Utils.getCookie = function (c_name) {
    if (document.cookie.length > 0) {
        var c_start = document.cookie.indexOf(c_name + "=");
        if (c_start != -1) {
            c_start = c_start + c_name.length + 1;
            var c_end = document.cookie.indexOf(";", c_start);
            if (c_end == -1) {
                c_end = document.cookie.length;
            }
            return unescape(document.cookie.substring(c_start, c_end));
        }
    }
    return "";
};
Utils.copyUrl = function (elementById) {
    var Url2 = document.getElementById(elementById);
    Url2.select(); // 选择对象
    var flag = document.execCommand("Copy"); // 执行浏览器复制命令
    document.execCommand("Unselect");
    return flag;
};


//压缩图片
Utils.compressImage = function (img, size, Orientation) {
    let canvas = document.createElement("canvas");
    let ctx = canvas.getContext('2d');
    //瓦片
    let tCanvas = document.createElement("canvas");
    let tctx = tCanvas.getContext('2d');
    let initSize = img.src.length;
    let width = img.width;
    let height = img.height;
    //如果图片大于4*size
    let ratio;
    if ((ratio = width * height / (4 * size)) > 1) {
        ratio = Math.sqrt(ratio);
        width = width / ratio;
        height = height / ratio;
    } else {
        ratio = 1;
    }
    // if((ratio = width*height / 4000000)>1){
    //     console.log("上传图片大于四百万像素");
    //     ratio = Math.sqrt(ratio);
    //     width = width/ratio;
    //     height = height/ratio;
    // }else{
    //     ratio = 1;
    // }
    canvas.width = width;
    canvas.height = height;
    //铺底色
    ctx.fillStyle = "#fff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    //如果图片大于1M则使用瓦片绘制
    let count;
    if ((count = width * height / size) > 1) {
        console.log("上传图片大于100w像素");
        count = Math.sqrt(count) + 1;
        let nw = width / count;
        let nh = height / count;
        tCanvas.width = nw;
        tCanvas.height = nh;
        for (let i = 0; i < count; i++) {
            for (let j = 0; j < count; j++) {
                tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh);
                ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
            }
        }
    } else {
        ctx.drawImage(img, 0, 0, width, height);
    }
    //修复ios上传图片的时候 被旋转的问题
    if (Orientation != "" && Orientation != 1) {
        switch (Orientation) {
            case 6://需要顺时针（向左）90度旋转
                this.rotateImg(img, 'left', canvas);
                break;
            case 8://需要逆时针（向右）90度旋转
                this.rotateImg(img, 'right', canvas);
                break;
            case 3://需要180度旋转
                this.rotateImg(img, 'right', canvas);//转两次
                this.rotateImg(img, 'right', canvas);
                break;
        }
    }
    //压缩
    let ndata = canvas.toDataURL('image/jpeg', 0.7);
    console.log("压缩前：" + initSize);
    console.log("压缩后：" + ndata.length);
    tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
    return ndata;
}
Utils.rotateImg = function (img, direction, canvas) {
    //最小与最大旋转方向，图片旋转4次后回到原方向
    const min_step = 0;
    const max_step = 3;
    if (img == null) return;
    //img的高度和宽度不能在img元素隐藏后获取，否则会出错
    let height = img.height;
    let width = img.width;
    let step = 2;
    if (step == null) {
        step = min_step;
    }
    if (direction == 'right') {
        step++;
        //旋转到原位置，即超过最大值
        step > max_step && (step = min_step);
    } else {
        step--;
        step < min_step && (step = max_step);
    }
    //旋转角度以弧度值为参数
    let degree = step * 90 * Math.PI / 180;
    let ctx = canvas.getContext('2d');
    switch (step) {
        case 0:
            canvas.width = width;
            canvas.height = height;
            ctx.drawImage(img, 0, 0);
            break;
        case 1:
            canvas.width = height;
            canvas.height = width;
            ctx.rotate(degree);
            ctx.drawImage(img, 0, -height);
            break;
        case 2:
            canvas.width = width;
            canvas.height = height;
            ctx.rotate(degree);
            ctx.drawImage(img, -width, -height);
            break;
        case 3:
            canvas.width = height;
            canvas.height = width;
            ctx.rotate(degree);
            ctx.drawImage(img, -width, 0);
            break;
    }
}
//js精度计算
Utils.fixNumMultiply = function (num1, num2) {
    var baseNum = 0;
    try {
        baseNum += num1.toString().split(".")[1].length;
    } catch (e) {
    }
    try {
        baseNum += num2.toString().split(".")[1].length;
    } catch (e) {
    }
    return Number(num1.toString().replace(".", "")) * Number(num2.toString().replace(".", "")) / Math.pow(10, baseNum);
}
Utils.fixNumDiv = function (num1, num2) {
    var baseNum1 = 0, baseNum2 = 0;
    var baseNum3, baseNum4;
    try {
        baseNum1 = num1.toString().split(".")[1].length;
    } catch (e) {
        baseNum1 = 0;
    }
    try {
        baseNum2 = num2.toString().split(".")[1].length;
    } catch (e) {
        baseNum2 = 0;
    }
    baseNum3 = Number(num1.toString().replace(".", ""));
    baseNum4 = Number(num2.toString().replace(".", ""));
    return (baseNum3 / baseNum4) * pow(10, baseNum2 - baseNum1);
}
Utils.fixNumAdd = function (num1, num2) {
    var number1, number2, m, n;
    try {
        number1 = num1.toString().split('.')[1].length;
    } catch (e) {
        number1 = 0;
    }
    try {
        number2 = num2.toString().split(".")[1].length;
    } catch (e) {
        number2 = 0;
    }
    m = Math.pow(10, Math.max(number1, number2));
    n = (number1 >= number2) ? number1 : number2;
    // return (num1*m+num2*m)/m;
    return ((num1 * m + num2 * m) / m).toFixed(n);
}
Utils.fixNumSub = function (num1, num2) {
    var number1, number2, m, n;
    try {
        number1 = num1.toString().split(".")[1].length;
    } catch (e) {
        number1 = 0;
    }
    try {
        number2 = num2.toString().split(".")[1].length;
    } catch (e) {
        number2 = 0;
    }
    m = Math.pow(10, Math.max(number1, number2));
    n = (number1 >= number2) ? number1 : number2;
    return ((num1 * m - num2 * m) / m).toFixed(n);
}
Utils.unescape = function (html) {
    return html
        .replace(html ? /&(?!#?\w+;)/g : /&/g, '&amp;')
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&quot;/g, "\"")
        .replace(/&#39;/g, "\'");
}
//通过字符串获取省市区
Utils.getArea = function (str) {
    let area = {}
    let index11 = 0
    let index1 = str.indexOf("省")
    if (index1 == -1) {
        index11 = str.indexOf("自治区")
        if (index11 != -1) {
            area.Province = str.substring(0, index11 + 3)
        } else {
            area.Province = str.substring(0, 0)
        }
    } else {
        area.Province = str.substring(0, index1 + 1)
    }

    let index2 = str.indexOf("市")
    if (index11 == -1) {
        area.City = str.substring(index11 + 1, index2 + 1)
    } else {
        if (index11 == 0) {
            area.City = str.substring(index1 + 1, index2 + 1)
        } else {
            area.City = str.substring(index11 + 3, index2 + 1)
        }
    }

    let index3 = str.lastIndexOf("区")
    if (index3 == -1) {
        index3 = str.indexOf("县")
        area.Country = str.substring(index2 + 1, index3 + 1)
    } else {
        area.Country = str.substring(index2 + 1, index3 + 1)
    }
    area.Address = str.substring(index3 + 1);
    return area;
}
Utils.getCurrentDate = function () {
    var date = new Date();
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();
    if (month < 10) {
        month = "0" + month;
    }
    if (day < 10) {
        day = "0" + day;
    }
    var currentDate = year + "-" + month + "-" + day;
    return currentDate;
}
Utils.getCurrentTime = function () {
    var date = new Date();
    var hour = date.getHours();
    var minute = date.getMinutes();
    if (hour < 10) {
        hour = "0" + hour;
    }
    if (minute < 10) {
        minute = "0" + minute;
    }
    return hour + ":" + minute;
}

Utils.getDomain = function () {
    let url = window.location.href;
    let result = "";
    let j = 0, startIndex = 0, endIndex = 0;
    for (let i = 0; i < url.length; i++) {
        if (url.charAt(i) == '/') {
            j++;
            if (j == 2)
                startIndex = i;
            else if (j == 3)
                endIndex = i;
        }

    }
    result = url.substring(startIndex + 1, endIndex);
    return result;
}
Utils.timeHandle = function(){
   const y = new Date().getFullYear().toString().padStart(2,'0');
   const m = (new Date().getMonth() + 1).toString().padStart(2,'0');
   const d = new Date().getDate().toString().padStart(2,'0'); 
   const startTime = `${y}-${m}-${d} 00:00:00`;
   const endTime = `${y}-${m}-${d} 23:59:59`;  
    return {
        startTime,
        endTime,
    }
}


export default Utils;



// WEBPACK FOOTER //
// ./src/utils/utils.js